import {createContext, useContext, useEffect, useRef, useState} from 'react';

// Same playback time as PlaybackTimeContext, but subscribed to instead of
// read from context, so a transcript row only re-renders when its own
// "is this playing" answer flips, not on every ~5x/second tick.
export const createPlaybackClock = () => {
  const listeners = new Set();
  let time = 0;

  return {
    getTime: () => time,
    subscribe: (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    publish: (nextTime) => {
      time = nextTime;
      listeners.forEach((listener) => listener(nextTime));
    }
  };
};

const PlaybackClockContext = createContext(createPlaybackClock());

export const useIsTimeInRange = (start, end) => {
  const clock = useContext(PlaybackClockContext);
  const [active, setActive] = useState(() => {
    const time = clock.getTime();
    return time >= start && time < end;
  });
  const activeRef = useRef(active);

  useEffect(() => {
    const update = (time) => {
      const next = time >= start && time < end;
      if (next === activeRef.current) return;
      activeRef.current = next;
      setActive(next);
    };

    update(clock.getTime());
    return clock.subscribe(update);
  }, [clock, start, end]);

  return active;
};

export default PlaybackClockContext;
